import script from "./RenewalPayment.vue?vue&type=script&setup=true&lang=js"
export * from "./RenewalPayment.vue?vue&type=script&setup=true&lang=js"

import "./RenewalPayment.vue?vue&type=style&index=0&id=0dd0454f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0dd0454f"]])

export default __exports__